import { Clerk } from "@clerk/clerk-js";
import { redirectToRoute } from "@/utils/userUtils";

let clerkInstance = null;
export async function sendEmailVerification(clientProvider) {
  await clientProvider.prepareEmailAddressVerification({
    strategy: "email_code",
  });
}

async function checkStatus({ clientProvider, firstCheck = false }) {
  const { status, createdSessionId, missingFields } = clientProvider;

  if (status === "complete") {
    if (
      createdSessionId &&
      !clerkInstance.client.sessions?.find((s) => s.id === createdSessionId)
    ) {
      try {
        await clerkInstance.client.reload();
      } catch {
        // continue to setActive even if reload fails
      }
    }
    await clerkInstance.setActive({ session: createdSessionId });
    await clerkInstance.environment?.reload();
    await clerkInstance.session?.touch();

    return true;
  } else if (status === "missing_requirements") {
    const needsEmailVerification = missingFields?.includes("email_address");

    if (needsEmailVerification) {
      if (firstCheck) {
        await sendEmailVerification(clientProvider);
      }

      this.$nextTick(() => {
        window.location.href = "/register#/verify-email-address";
      });

      return false;
    }
  } else {
    return false;
  }
}

export const getClerkInstance = () => clerkInstance;

export default async function initClerk(Vue) {
  if (!clerkInstance) {
    clerkInstance = new Clerk(process.env.VUE_APP_CLERK_PUBLISHABLE_KEY);
    await clerkInstance.load();
  }
  Vue.prototype.$initClerk = async function () {
    if (clerkInstance) {
      clerkInstance.checkStatus = checkStatus.bind(this);
      clerkInstance.addListener((args) => {
        const { user } = args;

        if (user) {
          redirectToRoute(this, user);
        }
      });

      const signUp = clerkInstance.client.signUp;
      const isOnLoginPage = window.location.pathname === "/login";
      const isOnRegisterPage = window.location.pathname === "/register";
      const shouldCheck =
        signUp.id &&
        !isOnLoginPage &&
        (!isOnRegisterPage || signUp.status === "complete");

      if (shouldCheck) {
        await clerkInstance.checkStatus({ clientProvider: signUp });
      }
    }

    return clerkInstance;
  };

  Vue.prototype.$getClerk = () => clerkInstance;
}
